import { GeoDsMeta } from './meta-data.model';
export class ApprovalStep extends GeoDsMeta{
    Decision?: string;
    DecisionDate?: string;
    DecisionReasoning?: string;
    SeqNr:number;
    ParentId: string;
    IdRefDecidedBy?: string;
    constructor(data) {
        super();
        Object.assign(this, data);
    }
}